import Theme from 'Theme';

import { COLORS, LIGHT_COLORS } from '../constants/orders';

export const getColor = (status, light) =>
  (light ? LIGHT_COLORS[status] : COLORS[status]) || Theme.primaryColor;

export default getColor;

